import { FC } from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'
import { IEmptyProps } from './types'

const Empty: FC<IEmptyProps> = ({
  className = '',
  cta,
  icon,
  text,
  title,
  variant = 'default',
  ...props
}: IEmptyProps) => {
  return (
    <section
      role="alert"
      className={clsx(
        styles.empty,
        {
          [styles.borderSolid]: variant === 'solid',
        },
        className,
      )}
      data-testid="mui-empty"
      {...props}
    >
      {icon && <span className={`${styles.icon}`}>{icon}</span>}
      <div className={styles.inner}>
        {title && <h3 className={`${styles.title}`}>{title}</h3>}
        {text && <span className={`${styles.text}`}>{text}</span>}
      </div>
      {cta}
    </section>
  )
}

export default Empty
